module.exports = __webpack_public_path__ + "img/LB2.189b8e69.png";